"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFiocInterstitial = void 0;
var useFiocInterstitial_hook_1 = require("./useFiocInterstitial.hook");
Object.defineProperty(exports, "useFiocInterstitial", { enumerable: true, get: function () { return useFiocInterstitial_hook_1.useFiocInterstitial; } });
//# sourceMappingURL=index.js.map